export default {
  title: 'Lista de sites',
  searchPlaceholder: 'Pesquise por um site',
  emptyResult: 'Não foram encontrados resultados para "{searchQuery}"'
}
